import { compose } from 'redux';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import Games from '../components/games/Games';
import { deleteGameAction, getGameAction } from '../store/actions';


const mapDispatchToProps = (dispatch) => {
    return {
        deleteGame: (id) => { dispatch(deleteGameAction(id)) },
        getAGame: (id) => { dispatch(getGameAction(id)) }
    }
}

const mapStateToProps = (state) => {
    return {
        games: state.firestoreData.ordered.games
    }
}

const GamesContainer =  compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect([
        { collection: 'games',
        where: ["approved", "==", true]
     }
    ])
)(Games);

export default GamesContainer;